import React from 'react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import { useIntl } from '@jetshop/intl';

import { theme } from '../Theme';

const campaignList = css`
  font-size: 0.875rem;
  margin-top: 20px;
  padding: 0;
  span {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 0.75em;
    color: ${theme.colors.black};
  }
  a {
    color: black;
    font-size: 12px;
    letter-spacing: 0.1px;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
  }
`;

const CampaignLink = styled(CategoryLink)`
  text-decoration: none;
  color: ${theme.colors.red};
`;

export function Campaigns({ campaigns, className, ...rest }) {
  const t = useIntl();

  if (!campaigns || campaigns.length === 0) {
    return null;
  }

  return (
    <div className={cx(campaignList, className)} {...rest}>
      <span>{t('Included in campaign:')}</span>
      <ul>
        {campaigns.map((campaign) => {
          return (
            <li key={campaign?.id}>
              <CampaignLink category={campaign}>{campaign?.name} </CampaignLink>
              {campaign?.activeDateSpan?.endDate && (
                <span style={{ fontWeight: '400' }}>
                  - Gäller t.o.m {''}
                  {new Date(
                    campaign?.activeDateSpan?.endDate
                  ).toLocaleDateString('Sv-Se')}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
